import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultStandardResource,
    StandardMutationResourceSchema,
    type StandardResource,
    useStandardActions,
} from '../../../../../resource/resources/artifacts/standard/standardResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { StandardContent } from './StandardContent';

export const StandardCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: StandardResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const standardActions = useStandardActions();
    const addStandard = standardActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: StandardMutationResourceSchema,
        defaultValues: {
            ...defaultStandardResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addStandard.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Standard'}
            resourceType={ResourceType.STANDARD}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <StandardContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
